import {
  Box,
  Button,
  Dialog,
  Form,
  Input,
  Message,
  NumberPicker,
  Select,
  Table,
  Tree,
} from '@alifd/next';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import EditService from '@/components/UI/EditService';
import useService from '@/lib/hooks/useService';
import { fetchUser } from '@/redux/slices/userSlice';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const Option = Select.Option;

const AccountAuthSetting = () => {
  const dispatch = useDispatch();
  // 取得頁面路徑資料
  // const [groupRouteData, setGroupRouteData] = useState([]);
  // const [pageData, setPageData] = useState('');
  // console.log(groupRouteData);
  // console.log(pageData);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const result = await axios
  //       .get('/ezcon/api/parseGroupRoute')
  //       .then((res) => setGroupRouteData(res.data))
  //       .catch((error) => console.log(error));
  //   };

  //   fetchData();
  // }, []);

  // 頁面權限設定
  const userGroup = client.service('userGroup');
  const users = client.service('users');

  const [categoryMenu] = useService({
    collectionName: 'categoryMenu',
    query: { service: 'serviceType' },
  })[0];

  const [userGroupArr, setUserGroupArr] = useState([]);
  const [roleCategory, setRoleCategory] = useState('');
  const [allowPage, setAllowPage] = useState(null);
  const [selectedService, setSelectedService] = useState('');
  const [userGroupEdit, setUserGroupEdit] = useState('');
  const [useGroupVal, setUseGroupVal] = useState(null);
  // console.log(useGroupVal)
  const [userGroupEditDialog, setUserGroupEditDialog] = useState(false);
  const [userGroupDialog, setUserGroupDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [curdataIndex, setcurDataIndex] = useState('name');
  const [curorder, setcurOrder] = useState('desc');
  const [userAuth, setUserAuth] = useState('');
  const [userRouter, setUserRouter] = useState('');
  const [originalName, setOriginalName] = useState();
  const [userArr, setUserArr] = useState([]);
  const [editOrder, setEditOrder] = useState();

  const user = useSelector((state) => state.user);

  // userGroup table

  // userGroup查詢
  function userGroupFind(para) {
    return new Promise((resolve, reject) => {
      try {
        userGroup.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  // userGroup新增
  function userGroupCreate(obj) {
    return new Promise((resolve, reject) => {
      userGroup
        .create(obj)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // userGroup更新
  function userGroupUpdate(id, obj) {
    console.log(id, obj, originalName);
    return new Promise((resolve, reject) => {
      userGroup
        .patch(id, obj)
        .then((result) => {
          client
            .service('users')
            .patch(
              null,
              {
                auth: obj.name,
              },
              {
                query: {
                  auth: originalName,
                },
              }
            )
            .then(() => {
              resolve(result);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  // userGroup刪除
  function userGroupRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        userGroup.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  function serverUserGroupUpdate() {
    userGroupFind({}).then((result) => {
      setUserGroupArr(result);
    });
  }
  useEffect(() => {
    serverUserGroupUpdate();
    funSortUpdate();
    users.find({}).then((result) => {
      console.log(result.data);
      setUserArr(result.data);
    });
  }, []);

  // checkbox
  const [userGroupRouteArr, setUserGroupRouteArr] = useState([]);

  useEffect(() => {
    // 20220324登入時查看權限是否為superAdmin 若為superAdmin 則看權限頁面;其餘則依照權限看userGroup-userRouter
    client.reAuthenticate().then((data) => {
      setUserAuth(data.user.auth);
      if (data.user.auth === 'superAdmin') {
        const userGroupRoute = client.service('userGroupRoute');
        userGroupRoute.find({}).then((result) => {
          setUserGroupRouteArr(result.data);
        });
      } else {
        const userGroup = client.service('userGroup');
        userGroup.find({ query: { name: data.user.auth } }).then((result) => {
          console.log(result);
          setUserGroupRouteArr(result.data[0].userRouter);
        });
      }
    });
  }, []);

  const [checkBoxData, setCheckBoxData] = useState({
    checkedKeys: [],
  });
  // console.log(checkBoxData)
  const { checkedKeys } = checkBoxData;

  const checkBoxDataNew = [];

  for (let i = 0; i < userGroupRouteArr.length; i++) {
    // 第一層
    const name = userGroupRouteArr[i].name;
    const icon = userGroupRouteArr[i].icon;
    const path = userGroupRouteArr[i].path;
    const order = userGroupRouteArr[i].order;
    const childrenLen = userGroupRouteArr[i].children;
    // console.log(childrenLen)

    let objParent = checkBoxDataNew.find((item) => item.label === name);
    // console.log(objParent)

    if (!objParent) {
      objParent = {
        order,
        icon,
        name,
        path,
        key: name,
        label: name,
        children: [],
      };
      checkBoxDataNew.push(objParent);
    }
    // 第二層

    for (let j = 0; j < childrenLen.length; j++) {
      const childrenName = childrenLen[j].name;
      const childrenPath = childrenLen[j].path;
      let objChildren = objParent.children.find(
        (item) => item.label === childrenName
      );
      if (!objChildren) {
        objChildren = {
          order,
          icon,
          fathername: name,
          fatherpath: path,
          name: childrenName,
          path: childrenPath,
          key: childrenName,
          label: childrenName,
        };
        objParent.children.push(objChildren);
      }
    }
  }
  // console.log(checkBoxDataNew)

  const handleCheck = (keys, info) => {
    // console.log(keys);
    const checkedNodes = info.checkedNodes; // 勾選的明細

    console.log(info);
    const checkedNodesNew = []; // 存入資料庫的資料

    for (let i = 0; i < checkedNodes.length; i++) {
      const newMap = {};
      // parent
      const childrenArr = checkedNodes[i].props.children;
      const childrenSingleArr = checkedNodes;

      if (!childrenArr || childrenArr.length === 0) {
        const parentElement = checkedNodesNew.find(
          (e) => e.name === checkedNodes[i].props.fathername
        );
        if (!parentElement) {
          // 父層沒有建立過
          newMap.icon = checkedNodes[i].props.icon;
          newMap.order = checkedNodes[i].props.order;
          newMap.name = checkedNodes[i].props.fathername;
          newMap.path = checkedNodes[i].props.fatherpath;
          newMap.children = [
            {
              name: checkedNodes[i].props.name,
              path: checkedNodes[i].props.path,
            },
          ];
          checkedNodesNew.push(newMap);
          setAllowPage(checkedNodesNew);
        } else if (
          !parentElement.children.find(
            (e) => e.name === checkedNodes[i].props.name
          )
        ) {
          parentElement.children.push({
            name: checkedNodes[i].props.name,
            path: checkedNodes[i].props.path,
          });
          setAllowPage(checkedNodesNew);
        }
      }
    }
    setCheckBoxData({
      checkedKeys: keys,
    });

    // 20220324 紀錄顯示使用者頁面權限
    const checkedNodesPositions = info.checkedNodesPositions;
    const newCheck = [];
    for (let i = 0; i < checkedNodesPositions.length; i++) {
      const newObject = {};
      const Popclass = checkedNodesPositions[i].pos.split('-');
      if (Popclass[2] !== undefined) {
        const childObject = {};
        childObject.name = checkedNodesPositions[i].node.key;
        childObject.path = checkedNodesPositions[i].node.props.path;
        if (newCheck[Popclass[1]]) {
          newCheck[Popclass[1]].children = [
            ...newCheck[Popclass[1]].children,
            childObject,
          ];
        } else {
          newObject.name = checkedNodesPositions[i].node.props.fathername;
          newObject.path = checkedNodesPositions[i].node.props.fatherpath;
          newObject.icon = checkedNodesPositions[i].node.props.icon;
          newObject.children = '';
          newObject.order = Number(Popclass[1]);
          newCheck[Popclass[1]] = newObject;
          newCheck[Popclass[1]].children = [
            ...newCheck[Popclass[1]].children,
            childObject,
          ];
        }
      } else {
        newObject.name = checkedNodesPositions[i].node.key;
        newObject.children = '';
        newObject.path = checkedNodesPositions[i].node.props.path;
        newObject.icon = checkedNodesPositions[i].node.props.icon;
        newObject.order = Number(Popclass[1]);
        newCheck[Popclass[1]] = newObject;
      }
    }
    console.log(newCheck);
    console.log(newCheck.filter((e) => e));
    setUserRouter(newCheck.filter((e) => e));
  };

  const funSortUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    userGroup.find({}).then((res) => {
      setUserGroupArr(
        res.data.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return (rorder === 'asc') === result > 0 ? 1 : -1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    funSortUpdate(dataIndex, order);
  };

  const handleServiceOptionChange = (value) => {
    setSelectedService(value.toString());
  };

  return (
    <>
      <Box spacing={20} direction="row" margin={[10, 'auto']}>
        <Button
          className={styles.addBtn}
          type="secondary"
          onClick={() => {
            setUserGroupDialog(true);
            setEditOrder(undefined);
          }}
        >
          頁面權限設定
        </Button>

        <EditService buttonProps={{ type: 'secondary' }} />
      </Box>

      {/* 新增頁面權限設定 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userGroupDialog}
        onOk={() => {
          if (!roleCategory && !allowPage) {
            Message.error('請確實填入角色設定和勾選頁面功能!!');
          } else if (!roleCategory) {
            Message.error('請確實填入角色設定!!');
          } else if (!allowPage) {
            Message.error('請確實勾選頁面功能!!');
          } else {
            Swal.fire({
              title: `確定新增(${roleCategory})權限?`,
              text: '請確認資料無誤!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire('成功!', '此權限新增成功', 'success');

                userGroupCreate({
                  name: roleCategory,
                  allow: allowPage,
                  key: checkBoxData,
                  order: editOrder,
                  userRouter,
                  service: selectedService,
                })
                  .then((res) => {
                    console.log('==userGroup create success', res);
                    setRoleCategory('');
                    setAllowPage('');
                    setCheckBoxData('');
                    setUserGroupDialog(false);
                    serverUserGroupUpdate();
                    // 創建完更新redux資料
                    dispatch(fetchUser());
                    Message.success('建立成功');
                  })
                  .catch((error) => {
                    console.log('==userGroup create fail:', error);
                    Message.error(`${error}`);
                  });
              }
            });
          }
        }}
        onCancel={() => {
          setRoleCategory('');
          setAllowPage('');
          setUserGroupDialog(false);
          setEditOrder(null);
        }}
        onClose={() => {
          setRoleCategory('');
          setAllowPage('');
          setUserGroupDialog(false);
          setEditOrder(null);
        }}
      >
        <div>
          <h3>頁面權限設定</h3>
          <Form.Item label="角色設定">
            <Input
              name="roleCategory"
              placeholder="請輸入權限類別"
              onChange={(value) => {
                setRoleCategory(value);
              }}
            />
          </Form.Item>

          <Form.Item label="服務類型">
            <Select
              onChange={handleServiceOptionChange}
              placeholder="請選擇服務類型"
            >
              {categoryMenu &&
                categoryMenu.data.map((category) => {
                  return <Option key={category.id} value={category.name} />;
                })}
            </Select>
          </Form.Item>

          <Form.Item label="頁面名稱">
            <div className="control-check-demo">
              <Tree
                style={{ maxHeight: '250px', overflow: 'auto' }}
                // defaultExpandAll
                checkable
                checkedKeys={checkedKeys}
                onCheck={handleCheck}
                dataSource={checkBoxDataNew}
              />
            </div>
          </Form.Item>
        </div>
      </Dialog>

      {/* 編輯頁面權限設定 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userGroupEditDialog}
        onOk={() => {
          if (!editOrder && editOrder !== 0) {
            Message.error('請確實填入位階!!');
          } else {
            const item = userGroupArr[userGroupEdit];

            item.name = roleCategory;
            item.allow = allowPage;
            item.key = checkBoxData;
            item.order = editOrder;
            // 20220324 若權限與編輯相同不可修改userRouter
            if (userAuth === 'superAdmin') item.userRouter = userRouter;
            Swal.fire({
              title: `確定修改(${roleCategory})權限?`,
              text: '請確認修改資料!!',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire('成功!', '此權限修改成功', 'success');
                userGroupUpdate(item._id, item)
                  .then((res) => {
                    serverUserGroupUpdate();
                    setRoleCategory('');
                    setAllowPage('');
                    setCheckBoxData('');
                    setUserGroupEditDialog(false);
                    console.log('==userGroup update success', res);
                    // 更新完更新redux資料
                    dispatch(fetchUser());
                    Message.success('更新成功');
                  })
                  .catch((error) => {
                    console.log('==userGroup update fail:', error);
                    // Message.error(`${err}`);
                  });
              }
            });
          }
        }}
        onCancel={() => {
          setRoleCategory('');
          setAllowPage('');
          setCheckBoxData('');
          setUserGroupEditDialog(false);
        }}
        onClose={() => {
          setRoleCategory('');
          setAllowPage('');
          setCheckBoxData('');
          setUserGroupEditDialog(false);
        }}
      >
        <div>
          <h3>編輯頁面權限設定</h3>
          <Form.Item label="角色設定">
            <Input
              name="roleCategory"
              value={roleCategory}
              placeholder="請輸入權限類別"
              onChange={(value) => {
                setRoleCategory(value);
              }}
              disabled={
                roleCategory === 'superAdmin' ||
                roleCategory === 'admin' ||
                roleCategory === 'app' ||
                roleCategory === 'guest' ||
                roleCategory === 'user'
              }
            />
          </Form.Item>
          {user?.userGroup?.order === 0 && (
            <Form.Item label="位階設定">
              <NumberPicker min={1} value={editOrder} onChange={setEditOrder} />
            </Form.Item>
          )}
          <Form.Item label="頁面名稱">
            <div className="control-check-demo">
              <Tree
                style={{ maxHeight: '250px', overflow: 'auto' }}
                // defaultExpandAll
                checkable
                checkedKeys={checkedKeys}
                onCheck={handleCheck}
                dataSource={checkBoxDataNew}
              />
            </div>
          </Form.Item>
        </div>
      </Dialog>

      {/* 頁面權限設定 */}
      <Table dataSource={userGroupArr} onSort={onTableSort}>
        <Table.Column title="服務類型" dataIndex="service" width={100} />
        {user.userGroup.order === 0 && (
          <Table.Column title="位階" dataIndex="order" width={100} />
        )}
        <Table.Column sortable title="角色設定" dataIndex="name" width={200} />
        <Table.Column
          title="頁面名稱"
          dataIndex="allow"
          width={600}
          cell={(value, index, record) => {
            //  console.log('==op ', value, index, record);
            return (
              <div>
                {userGroupArr[index].allow.map((list, index) => {
                  return (
                    <ol key={index}>
                      <li> {`功能:${list.name}`}</li>
                      {/* <li>{`父路徑:${list.path}`}</li> */}
                      {/* <ul>
                        {list.children.map((list, index) => {
                          return (
                            <div key={index}>
                              <li>{`子名稱:${list.name}`}</li>
                              <li>{`子路徑:${list.path}`}</li>
                            </div>
                          );
                        })}
                      </ul> */}
                    </ol>
                  );
                })}
              </div>
            );
          }}
        />
        <Table.Column
          title="操作"
          width={200}
          lock="right"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);
            return (
              <div className={styles.btn}>
                <Button
                  type="normal"
                  onClick={() => {
                    setRoleCategory(userGroupArr[index].name);
                    setAllowPage(userGroupArr[index].allow);
                    setCheckBoxData(userGroupArr[index].key);
                    setUserRouter(userGroupArr[index].userRouter);
                    setUserGroupEdit(index);
                    setUserGroupEditDialog(true);
                    setOriginalName(record.name);
                    setEditOrder(record.order);
                  }}
                >
                  編輯
                </Button>
                {record.name !== 'superAdmin' &&
                  record.name !== 'admin' &&
                  record.name !== 'app' &&
                  record.name !== 'guest' &&
                  record.name !== 'user' && (
                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        const item = userGroupArr[index];
                        const userAuth = userArr.filter(
                          (item) => item.auth.indexOf(record.name) >= 0
                        ).length;
                        Swal.fire({
                          title: `確定刪除(${record.name})權限?`,
                          text:
                            userAuth > 0
                              ? '此權限有綁定住戶，若確認刪除將會同步移除住戶權限'
                              : '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此權限已刪除', 'success');
                            userGroupRemove(item._id).then(() => {
                              // 刪除完更新redux資料
                              dispatch(fetchUser());
                              serverUserGroupUpdate();
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  )}
              </div>
            );
          }}
        />
      </Table>
    </>
  );
};

export default AccountAuthSetting;
